export default "__VITE_ASSET__Cn3lqM3u__"